import { useEffect, useState } from 'react';

import { useTheme } from 'styled-components';

import { YogaTheme } from 'types/others';

const UseRandomColors = (
  colorsAmount = 1,
  repeatSameColorInARow = false,
  overrideColors?: string[],
) => {
  const theme = useTheme() as YogaTheme;
  const [colors, setColors] = useState<string[]>([]);

  const lastUsedColor = colors[colors?.length - 1];

  const initialColors: string[] = overrideColors || [
    theme.yoga.colors.primaryLight,
    theme.yoga.colors.secondary,
    theme.yoga.colors.buttery,
  ];

  const generateNewColor = (filterColor?: string) => {
    let availableColors;

    if (!repeatSameColorInARow) {
      availableColors = initialColors.filter(
        availableColor => availableColor !== filterColor,
      );
    } else {
      availableColors = initialColors;
    }

    return availableColors[Math.floor(Math.random() * availableColors.length)];
  };

  const generateColorsSlice = () => {
    const colorsSlice: string[] = [];

    for (let i = 0; i < colorsAmount; i += 1) {
      const lastColorSlice =
        colorsSlice[colorsSlice.length - 1] || lastUsedColor;

      colorsSlice.push(generateNewColor(lastColorSlice));
    }

    setColors([...colors, ...colorsSlice]);
  };

  useEffect(() => {
    generateColorsSlice();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [colorsAmount]);

  return { color: colors[0], colors, generateNewColor, generateColorsSlice };
};

export default UseRandomColors;
